// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width:768px) and (max-width:991px){

.mark-svg svg{
    width: 15px!important;
}
}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/FaceInjectionPointsLenisna.css"],"names":[],"mappings":"AAAA;;AAEA;IACI,qBAAqB;AACzB;AACA","sourcesContent":["@media(min-width:768px) and (max-width:991px){\n\n.mark-svg svg{\n    width: 15px!important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
